module.exports = __webpack_public_path__ + "img/blue-tick.a2eb9ed5.svg";